import React, { useState, useEffect } from 'react';
import './DeveloperOverlay.css';

const DeveloperOverlay = () => {
  const [enabled, setEnabled] = useState(false);
  const [selectedInfo, setSelectedInfo] = useState(null);

  useEffect(() => {
    if (!enabled) return;

    const handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();

      const element = e.target;
      const path = window.location.pathname;
      const tagName = element.tagName;
      const classNames = element.className;
      const innerText = element.innerText;

      setSelectedInfo({ path, tagName, classNames, innerText });
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, [enabled]);

  return (
    <div className="developer-overlay">
      <button className="toggle-button" onClick={() => setEnabled(!enabled)}>
        {enabled ? 'Disable Dev Overlay' : 'Enable Dev Overlay'}
      </button>

      {enabled && selectedInfo && (
        <div className="info-sidebar">
          <h4>Selected Component Info</h4>
          <p><strong>Path:</strong> {selectedInfo.path}</p>
          <p><strong>Tag:</strong> {selectedInfo.tagName}</p>
          <p><strong>Class:</strong> {selectedInfo.classNames}</p>
          <p><strong>Text:</strong> {selectedInfo.innerText}</p>
        </div>
      )}
    </div>
  );
};

export default DeveloperOverlay;
